import {IFormField} from './formField.interface';

import {Component, Inject, Input} from 'ng-metadata/core';
import {FormFieldService} from './formField.service';
import {FormBuilderEnums} from '../formBuilder.service';
//your imports go here
var angular: angular.IAngularStatic = require('angular');
const forEach = require('lodash/forEach');
const uniqBy = require('lodash/uniqBy');
const uniq = require('lodash/uniq');
const dateFormat = require('dateformat');

@Component({
    selector: 'prm-form-field',
    templateUrl: 'components/infra/formBuilder/field/form-field.html'
})


export class PrmFormField {

    @Input() public field: IFormField;
    @Input() public data;
    @Input() public form: Object;

    public filterDates = angular.bind(this, this.filterDatesUnbound);

    private fieldUiTypeHtml: Object;


    /* date dropdown */
    private days: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'
        , '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
    private months: string[] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    private hours: string[] = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'
        , '21', '22', '23'];
    private minutes: string[] = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'
        , '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46',
        '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'];
    private yearRegex = '\\d+';

    private delayForLabels: boolean = false;

    constructor(private formFieldService: FormFieldService,
                @Inject('actionIcons') public actionIcons,
                @Inject('$timeout') private $timeout) {
        this.fieldUiTypeHtml = {
            text: 'components/infra/formBuilder/field/form-field-text.html',
            textarea: 'components/infra/formBuilder/field/form-field-textarea.html',
            checkbox: 'components/infra/formBuilder/field/form-field-checkbox.html',
            readonly: 'components/infra/formBuilder/field/form-field.html',
            password: 'components/infra/formBuilder/field/form-field.html',
            dropdown: 'components/infra/formBuilder/field/form-field-dropdown.html',
            radio: 'components/infra/formBuilder/field/form-field-radio.html',
            date: 'components/infra/formBuilder/field/form-field-date.html',
            label: 'components/infra/formBuilder/field/form-field-label.html',
            multiLabel: 'components/infra/formBuilder/field/form-field-multi-label.html',
            hidden: 'components/infra/formBuilder/field/form-field-hidden.html',
            link: 'components/infra/formBuilder/field/form-field-link.html',
            datetime: 'components/infra/formBuilder/field/form-field-datetime.html',
            dateAndTime: 'components/infra/formBuilder/field/form-field-dateAndTime.html',
            dateDropdown: 'components/infra/formBuilder/field/form-field-date-dropdown.html',
            dateNgrs: 'components/infra/formBuilder/field/form-field-date-needed-by.html',
        };
        /*There is a bug in angular-material that sometimes labels aren't presented because that 'translate' in the <label> with the combination
        of the drop down didn't finish to load*/
        this.$timeout(() => {
            this.delayForLabels = true
        }, 400);
    }

    public expandList(id) {
        document.querySelector('*[name="' + this.field.name + '"]').click();
    }


    /* getter / setter */
    get formData() {
        return this.data;
    }

    set formData(data) {
        this.data = data;
    }

    get errorMsgPlaceholders() {
        return {idx_0: `<span class="lowercase">{{::"${this.field.label}" |translate}}</span>`};
    }

    /* public functions */
    public getFormFieldHtml() {
        if (!this.field || !this.fieldUiTypeHtml[this.field.uiType]) {
            this.field.uiType = 'text';
        }
        return this.fieldUiTypeHtml[this.field.uiType];
    }

    public getCatagories() {
        if (!this.field.options) {
            return [];
        }

        let array = this.field.options.map((value, index, array1) => this.parseCatagories(value)).filter(this.filterEmpty);
        return uniq(array);
    }

    public getCurrentDate() {
        let now = new Date();
        return dateFormat(now, "yyyy-mm-dd'T'HH:MM:ss");
    }

    private parseCatagories(option) {
        return option.category;
    }

    private filterEmpty(e) {
        return e;
    }

    public filterDatesUnbound(date) {
        if (!this.field) {
            return true;
        }

        /* check filter dates by allow in populator (params) */
        if (this.field.populator && this.field.populator.params && this.field.populator.params.allow) {
            return (this.field.populator.params.allow === FormBuilderEnums.FUTURE_DATES && date >= new Date().setHours(0, 0, 0, 0));
        }

        if (!this.field.options || this.field.options.length <= 0) {

            return true;
        }

        /* check filter dates by allow in populator (params) */
        if (this.field.populator && this.field.populator.params && this.field.populator.params.allow) {
            return (this.field.populator.params.allow === FormBuilderEnums.FUTURE_DATES && date >= new Date().setHours(0, 0, 0, 0));
        }

        if (!this.field.options || this.field.options.length <= 0) {
            return true;
        }

        let found = false;
        forEach(this.field.options, (option) => {
            if (!found) {
                found = (date.getDate() === option.day &&
                    date.getMonth() + 1 === option.month &&
                    date.getFullYear() === option.year);
            }
        });

        return found;

    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/formBuilder/field/formField.directive.ts